<template>
	<section>
		<!--Toolbar -->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true">        
				<el-form-item>
          <el-select  style='width:300px' clearable autocomplete filterable @change="openGroup"
                      v-model="stat" placeholder='Select Global Statistic' >
            <el-option v-for="item in codes.statcodes" 
  	  			           :key='item.code' 
				  	           :label="item.value" 
					  	  			 :value='item.code'></el-option>
  		    </el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon='el-icon-search' size='small' v-on:click="openGroup">Open</el-button>
				</el-form-item>
        
				<span style='float:right'>
  				<el-form-item>
	  				<el-button type="primary" size="small" @click="openGroup">Refresh</el-button>
		  		</el-form-item>
				</span>
			</el-form>
		</el-col>

		<!--Lijst-->
		<el-table :data="content"  :cell-style="{height: '32px'}" stripe highlight-current-row v-loading="listLoading" style="width: 100%;">
      <el-table-column prop="code" label="Subject" width="150" sortable></el-table-column>
      <el-table-column prop="date" label="Created" width="150" sortable></el-table-column>
      <el-table-column prop="details" label="Input" min-width="200" sortable></el-table-column>
      <el-table-column prop="total" label="Total" width="60">
        <template slot-scope="scope">{{(scope.row.total != 0) ? scope.row.total : ''}}</template>
      </el-table-column>
      <el-table-column prop="added" label="Added" width="70">
        <template slot-scope="scope">{{(scope.row.added != 0) ? scope.row.added : ''}}</template>
      </el-table-column>
      <el-table-column prop="modified" label="Modified" width="90">
       	<template slot-scope="scope">{{(scope.row.modified != 0) ? scope.row.modified : ''}}</template>
      </el-table-column>
      <el-table-column prop="deleted" label="Deleted" width="80">
       	<template slot-scope="scope">{{(scope.row.deleted != 0) ? scope.row.deleted : ''}}</template>
      </el-table-column>
      <el-table-column prop="errors" label="Errors" width="60">
       	<template slot-scope="scope">{{(scope.row.errors != 0) ? scope.row.errors : ''}}</template>
      </el-table-column>
      <el-table-column prop="warnings" label="Warnings" width="80">
      	<template slot-scope="scope">{{(scope.row.warnings != 0) ? scope.row.warnings : ''}}</template>
      </el-table-column>

		</el-table>

		<!-- Toolbar -->
		
		<el-col :span="24" class="toolbar">
			<el-pagination layout="prev,pager,next,jumper,sizes" @current-change="selectPage" :total="mainTotal" style="float:right;"
                     :page-sizes="[10, 15, 25, 50, 100]" @size-change="selectPagesize" :page-size="pageSize"></el-pagination>
      <span style='font-size:80%;margin:9px;float:right'>{{mainTotal}} records found</span>
      </el-col>
	</section>
</template>

<script>
  import settings from '../../common/AppSettings';
 	import util     from '../../common/AppUtil';
  import text     from '../../common/AppText';
  import api      from '../../api/bas/xstat';

	export default {
		data() {
			return {
        QID         : util.Initialize(this.$router,"XST"),
        util        : util,
        stack       : {},
			  lang        : text.data,
        codes       : util.codes,
				pageSize    : settings.pageSize,
 		  	serverPaging: false,
        stat        : "",
				editTitle   : "",
				editMode    : "",
				APICode     : "XStat",
				mainFunc    : "XStat",
				mainSubject : "XStat",
        mainKey     : "code",
				mainKeyDesc : "code",
        searchFilter: '',				
        content: [],
				counter: {},
				related: [],
				currentPage: 1,
				mainTotal: 0,
		
				listLoading: false,
				editFormVisible: false,// Of de bewerkingsinterface wordt weergegeven
				editLoading: false,
				editForm: {},			
				editFormRules: {
					code: [
						{ required: true, message: text.data.mandatory, trigger: 'blur' }
					]
				},

			}
		},
		
		methods: {
 	  	closeForm: function () {
         this.selectorVisible = false;
	  		this.$router.push({name: 'Statistics',params: this.stack});
    	},


		  openGroup: function() {
        this.content = [];        
        this.getRecords();
      },
    // paginering wissel, reload page			
		  selectPagesize: function(size) {
				settings.pageSize = size;
				this.showPagedData();
			},
			selectPage: function(page) {
				this.currentPage = page;								
				this.showPagedData();
			},
			showPagedData: function() {
				if (this.serverPaging) this.getRecords();
				else this.content = this.contentSaved.slice((this.currentPage - 1) * 
				                    settings.pageSize,this.currentPage * settings.pageSize);
      },

			// Ophalen record(s) via API
			getRecords() {

        let parg = {};
        parg.Params = {};
        parg.Params.code = this.stat;
        parg.Params.path = this.$route.path;

				this.listLoading = true;
  
				api.getSanityPage(parg).then((res) => {						
          util.processMainResults(res);
          this.content = [];

          if (this.codes) this.codes = util.codes;          
       

          if (util.getMainPayload(this.APICode)) {
            this.content = util.getMainPayload(this.APICode);
            this.mainTotal = this.content.length;
          }
					else {
            this.content = [];
            this.contentSaved = [];
          }
          this.listLoading = false;
				})
        .catch((error) => {
          util.serverError(this);
        });


			},
			

			openRelated: function(row) {       
			},

			// Verwijder
			handleDel: function (row) {
				this.$confirm(text.getText("sdelM",this.mainSubject,row[this.mainKeyDesc]), 'Confirm', {
					type: 'warning',title: text.getText("sdelT",this.mainSubject)
				}).then(() => {
					this.listLoading = true;

				  let parg = Object.assign({}, row);

				  api.removeRecord(parg).then((res) => {
						this.listLoading = false;
  					this.$notify({
	  				  title: text.data.conf,type: 'success',
		  				message: text.getText("delOK",this.mainSubject,row[this.mainKey])			  			              
				  	});
						this.getRecords();
					});

				}).catch(() => {

				});
			},
      rowClass:function(row,index) {
        return "row";
      },
			
			// Display bewerkingsinterface
			handleEdit: function (row) {
        this.editMode = "save";
				this.editTitle = text.getText("modM",this.mainSubject,row[this.mainKey]);
				this.editFormVisible = true;        
				this.editForm = Object.assign({}, row);
        //this.$nextTick(() => this.$refs.firstEdit.focus());
			},
			
			
			// Toon nieuwe interface
			handleAdd: function () {
				this.editMode = "add";
				this.editTitle = text.getText("addM",this.mainSubject);
				this.editFormVisible = true;
				this.editForm = {};
        this.editForm["statcode"] = this.code;
        //this.$nextTick(() => this.$refs.firstAdd.focus());
			},

			// uitgeven
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
					  this.editLoading = true;
						
            let parg = {};
            parg.Params = {};
            parg.Record = Object.assign({}, this.editForm);

            if (this.editMode == "add") 
            {
							api.addRecord(parg).then((res) => {
                util.processMainResults(res);
                if (util.header.OK)
                  this.$notify({title: text.data.done, type: 'success',
								                message: text.getText("addOK",this.mainSubject,this.editForm.showorder)});
                else this.$notify({title: "Error",type: 'error',message: util.header.message});
		    				this.$refs['editForm'].resetFields();
        				this.editLoading = false;  
	  		    		this.editFormVisible = false;
   			 	  		this.getRecords();
	  					});
            }
						else {
							api.saveRecord(parg).then((res) => {		  					
                util.processMainResults(res);
                if (util.header.OK)
                  this.$notify({title: text.data.done, type: 'success',
								                message: text.getText("modOK",this.mainSubject,this.editForm.showorder)});
                else this.$notify({title: "Error",type: 'error',message: util.header.message});
						    this.$refs['editForm'].resetFields();
        				this.editLoading = false;  
	  		    		this.editFormVisible = false;
		    				this.getRecords();
	  					});
            }
					}
				});
			},

		},

		mounted() {

      window.addEventListener("popstate", (event) => {
        this.closeForm();
      });

      if (this.$route.params) {
        this.stack = this.$route.params;
      }

      this.getRecords();
		}
	}

</script>

<style scoped>
.row {line-height:50px !important}
</style>


// WEBPACK FOOTER //
// xsanity.vue?67598c33